<template>
    <div class="parent-container">
        <div class="content-container">
            <div class="topic-sign-title-top">结题资料审核</div>
            <div class="topic-sign-name">（{{info.topicName}}）</div>
            <div class="topic-info-container">
                <div class="topic-info-left">
                    <div class="item-title-container">
                        <div :class="activeTab===1?'item-title title-active':'item-title'" @click="handleTabsClick(1)">基本信息</div>
                        <div :class="activeTab===2?'item-title title-active':'item-title'" @click="handleTabsClick(2)">辅助材料</div>
                    </div>
                    <el-form ref="topicForm" :model="info" :label-width="100" label-position="top">
                        <el-scrollbar class="topic-info-bar" v-if="activeTab===1">
                            <div class="topic-sign-title">
                                核心报告类材料
                            </div>
                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    <span style="color: red">*</span>结题报告
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.jtbgFileList" :key="item">
                                        <div class="file-title">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                                        </div>
                                    </div>
                                    <div class="div-100" v-if="info.jtbgFileList&&info.jtbgFileList.length===0">
                                        <dataEmpty title="暂无数据" />
                                    </div>
                                </div>
                            </div>
                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    工作报告
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.gzbgFileList" :key="item">
                                        <div class="file-title">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                                        </div>
                                    </div>
                                    <div class="div-100" v-if="info.gzbgFileList&&info.gzbgFileList.length===0">
                                        <dataEmpty title="暂无数据" />
                                    </div>
                                </div>
                            </div>

                            <div class="topic-sign-title">
                                成果类材料
                            </div>
                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    论文与著作
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.lwzzFileList" :key="item">
                                        <div class="file-title">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                                        </div>
                                    </div>
                                    <div class="div-100" v-if="info.lwzzFileList&&info.lwzzFileList.length===0">
                                        <dataEmpty title="暂无数据" />
                                    </div>
                                </div>
                            </div>
                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    教学案例与课件
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.alkjFileList" :key="item">
                                        <div class="file-title">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                                        </div>
                                    </div>
                                    <div class="div-100" v-if="info.alkjFileList&&info.alkjFileList.length===0">
                                        <dataEmpty title="暂无数据" />
                                    </div>
                                </div>
                            </div>
                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    获奖证书
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.hjzsFileList" :key="item">
                                        <div class="file-title">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                                        </div>
                                    </div>
                                    <div class="div-100" v-if="info.hjzsFileList&&info.hjzsFileList.length===0">
                                        <dataEmpty title="暂无数据" />
                                    </div>
                                </div>
                            </div>
                        </el-scrollbar>
                        <el-scrollbar class="topic-info-bar" v-if="activeTab===2">
                            <!--附件内容 -->
                            <div class="topic-sign-title">
                                附件
                            </div>
                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    附件资料
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.jtfjFileList" :key="item">
                                        <div class="file-title">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                                        </div>
                                    </div>
                                    <div class="div-100" v-if="info.jtfjFileList&&info.jtfjFileList.length===0">
                                        <dataEmpty title="暂无数据" />
                                    </div>
                                </div>
                            </div>

                        </el-scrollbar>
                    </el-form>
                </div>
                <div class="topic-info-right">
                    <div class="check-user-info">审核:{{info.ktCheckUserName}}</div>
                    <div class="check-sel">
                        <div class="btn-tg" @click="handleCheckChange(3)"><span v-if="checkForm.isCheck===3">√</span>通过</div>
                        <div class="btn-jj" @click="handleCheckChange(4)"><span v-if="checkForm.isCheck===4">√</span>驳回</div>
                    </div>
                    <div class="reason-title-container">
                        不通过原因
                    </div>
                    <div class="reason-container">
                        <el-input v-model="checkForm.reason" type="textarea" rows="6" />
                    </div>
                    <div class="apply-btn-container" >
                        <div class="apply-btn-back" @click="backTopicManager">返回</div>
                        <div v-if="info.jtStatus===2&&userId===info.jtCheckUser" class="apply-btn" @click="submitCheckInfo">确认</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import { infoTopicSign,checkTopicSign } from "@/api/admin/topicSign"
import {timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import {downloadFile} from "@/api/adminservice/public";
import dataEmpty from "@/components/dataEmpty.vue";
export default {
    name: "bmTopicCheck",
    components: {dataEmpty},
    data() {
        return {
            serviceUrl,
            timestampToTime,
            activeTab:1,
            signId:'',
            status:0,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            info:{},
            periodList: [],
            subjectList: [],
            qualificationList:[],
            rankList:[],
            checkForm:{
                signId:'',
                isCheck:"",
                status:4,
                reason:"",
            }
        };
    },
    created() {},
    mounted() {
        if (this.$route.query.signId) {
            this.signId = this.$route.query.signId
            this.checkForm.signId = this.signId
            this.getTopicSignInfo()
        }
    },
    unmounted() {},
    computed: {},
    methods: {
        getQueryDict() {
            /*档案学段学科*/
            queryDict({ code: 'archive_xd_xk' }).then(res => {
                this.periodList = res.data.data;
                this.subjectList = [];
                this.periodList.forEach(j => {
                    if (this.info.periodKey === j.dictKey) {
                        this.subjectList = j.childrenList;
                    }
                })
            })
            /*最高学历*/
            queryDict({ code: 'qualification' }).then(res => {
                this.qualificationList = res.data.data;
            })
            /*技术职称*/
            queryDict({ code: 'technical_title' }).then(res => {
                this.rankList = res.data.data;
            })
        },
        handleTabsClick(item){
            this.activeTab = item;
        },
        getTopicSignInfo() {
            infoTopicSign({ signId: this.signId }).then(res => {
                  if (res.data.code === 1) {
                      this.info = res.data.data;
                      this.getQueryDict()
                  }else {
                      this.$message.error("请求出错")
                  }

            })
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {

            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,fileType,fileUrl){
            const list = [];
            if (fileType &&(fileType.toLowerCase()==='png'||fileType.toLowerCase()==='jpg'||fileType.toLowerCase()==='jpeg')){
                list.push(fileUrl);
            }else {
                for (let i = 1; i <=page ; i++) {
                    list.push(baseUrl+'/' + i+'.png');
                }
            }

            return list;
        },
        handleCheckChange(selItem){
            this.checkForm.isCheck = selItem;
        },
        submitCheckInfo(){
            if (!this.checkForm.isCheck){
                this.$message.error("请选择是否通过")
                return;
            }

            if (this.checkForm.isCheck === 4&& !this.checkForm.reason) {
                this.$message.error("驳回请输入原因")
                return;
            }
            checkTopicSign(this.checkForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功")
                    this.backTopicManager();
                }else{
                    this.$message.error("请求出错")
                }
            })

        },
        backTopicManager(){
            this.$router.push({
                path: "/subTopicManager",
                query: {
                    topicId: this.info.topicDirection,
                }
            });
        }

    }
};
</script>
<style scoped>
.parent-container{
    height: 100%;
    width: 100%;
    padding: 10px 10px 20px 20px;
    box-sizing: border-box;
}
.content-container{
    height: 100%;
    width: 100%;
    background-color: #fff;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.topic-sign-title-top{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #3b62f8;
    margin-top: 5px;
    text-align: center;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    font-size: 15px;
    text-align: center;
}
.topic-info-container{
    width: 100%;
    height: auto;
    border-top: 2px solid #3b62f8;
    display: flex;
}
.topic-info-left{
    width: calc(100% - 262px);
    height: 100%;
    border-right: 2px solid #3b62f8;
}
.topic-info-right{
    width: 260px;
    height: 100%;
}
.item-title-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.item-title{
    width: auto;
    height: 30px;
    margin-right: 10px;
    line-height: 30px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;
}
.title-active{
    color: #3b62f8!important;
    border-bottom: 3px solid #3b62f8!important;
}
.topic-info{
    width: 100%;
    height:100%;
    padding-top: 10px;
}
.topic-info-bar{
    width: 100%;
    height:calc(100vh - 220px);
    padding-top: 10px;
}
/deep/ .el-form-item{
    margin-bottom: 10px!important;
}
/deep/ .el-form-item__label{
    color:#000!important;
    font-weight:bold;
    font-size:14px
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    color:#000!important;
    font-weight:bold;
    font-size:14px;
    line-height: 25px;
}
.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.file-item:hover{
    color: #3b62f8!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    color: #3b62f8;
}
.file-view{
    width: 32px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        cursor: pointer;
    }
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 22px;
    height: 22px;
    cursor: pointer;
}
.check-user-info{
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
}
.check-sel{
    width: 100%;
    height: 40px;
    margin: auto;
    display: flex;
}
.btn-tg{
    height: 24px;
    width: 70px;
    background-color: #81b337;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    margin-right: 10px;
    border-radius: 5px;
    margin-left: 60px;
    cursor: pointer;
}
.btn-jj{
    height: 24px;
    width: 70px;
    background-color: #e87b17;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
}
.reason-title-container{
    display: flex;
    width: 100%;
    height: 25px;
    color:#000!important;
    font-weight:bold;
    font-size:14px;
    line-height: 25px;
    text-indent: 10px;
}
.reason-container{
    width: 100%;
    height: auto;
    padding-left: 10px;
    padding-top: 10px;
    box-sizing: border-box;

}
.apply-btn-container{
    width: 100%;
    height: 40px;
    padding-top: 30px;
    display: flex;
}
.apply-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #3b62f8;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.apply-btn-back{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #FFFFFF;
    color: #909399;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
    border: 1px solid #909399;
}

.topic-file-container{
    width: 98%;
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
}
.topic-file-item-title{
    height: 30px;
    color:#333333;
    font-weight:bold;
    font-size:14px
}
.topic-sign-title{
    display: flex;
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
}
</style>